import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  AppParamItems,
  AppParamsService,
} from 'src/app/shared/app-params.service';
import { environment } from 'src/environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  imports: [MatToolbarModule, MatIconModule]
})
export class ToolbarComponent implements OnInit, OnDestroy {
  private readonly appParamService = inject(AppParamsService);
  private readonly deviceDetector = inject(DeviceDetectorService);
  
  canBeVisible = signal<boolean>(true);
  auctionName = signal<string>(environment.auctionName);
  contactNumber = signal<string>('');

  ngOnInit(): void {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;

    this.canBeVisible.set(
      isStandalone &&
      (this.deviceDetector.isMobile() || this.deviceDetector.isTablet()));

    if (this.canBeVisible()) {
      this.appParamService
        .watchFor(AppParamItems.AppParamGeneral.contactNumber)
        .subscribe((val) => this.contactNumber.set(val));
    }
  }

  ngOnDestroy(): void {
    this.appParamService.dispose(AppParamItems.AppParamGeneral.contactNumber);
  }

  openChat() {
    let numberWithCountryCode = this.contactNumber();
    if (
      !this.contactNumber().startsWith('57') &&
      !this.contactNumber().startsWith('+57')
    ) {
      numberWithCountryCode = '57' + this.contactNumber;
    }

    window.open('https://api.whatsapp.com/send?phone=' + numberWithCountryCode);
  }
}
